import React, {Component} from 'react';
import DocumentResult from './DocumentResult/DocumentResult';
import './SearchResult.css';
import Product from "../../Listview/Product/Product";
import Equalizer from 'react-equalizer';
import Spinner from "../../Elements/Spinner/Spinner";

class SearchResult extends Component {
    render() {
        let documents;
        let products;
        if(this.props.results !== null) {
            if(typeof this.props.results.documents !== "undefined" && this.props.results.documents.length > 0) {
                documents = (
                    <div className="document-results">
                        <h2>Gefundene Treffer in Dokumente</h2>
                        <table className="table table-striped">
                            <tbody>
                            {this.props.results.documents.map(function(name,index){
                                return <DocumentResult changeRoute={this.props.changeRoute} setFile={this.props.setFile} height={this.props.height} width={this.props.width} document={name} key={index} />
                            }.bind(this))}
                            </tbody>
                        </table>
                    </div>
                )
            }


            if(typeof this.props.results.products !== "undefined" && this.props.results.products.length > 0) {
                products = (
                    <div className="product-results">
                        <h2>Gefundene Treffer in Produkte</h2>
                        <Equalizer byRow={false}>
                            {this.props.results.products.map(function(name,index){
                                return <Product product={name} key={index} setProduct={this.props.setProduct} changeRoute={this.props.changeRoute} />
                            }.bind(this))}
                        </Equalizer>
                        <div className="clearfix"></div>
                    </div>
                )
            }
            return (
                <div className="SearchResult">
                    {products}
                    {documents}
                </div>
            )
        }else{
            return <Spinner message="" />;
        }

    }
}

export default SearchResult;


// WEBPACK FOOTER //
// ./src/Components/Search/SearchResult/SearchResult.js